import { render } from "./BangIcon.vue?vue&type=template&id=31118aec&scoped=true"
import script from "./BangIcon.vue?vue&type=script&lang=js"
export * from "./BangIcon.vue?vue&type=script&lang=js"

import "./BangIcon.vue?vue&type=style&index=0&id=31118aec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31118aec"

export default script